// NPM Imports
import React, { Component } from "react";
import { connect } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

// Actions Imports
import AuthActions from "../../../actions/AuthActions";

// Internal Imports
import { EVENTS } from "../../../constants";
import { AmplitudeUtils } from "../../../utils";

// Destructuring
const { signOutUser } = AuthActions;

class SignOut extends Component {
  state = {};

  _signOutUser = () => {
    AmplitudeUtils.amplitudeLogEvent(EVENTS.EVENT_NAMES.USER_SIGNOUT);
    signOutUser();
  };

  render() {
    return (
      <div
        className="nav-profile-menuitem"
        onClick={this._signOutUser}
        onKeyPress={this._signOutUser}
        role="button"
        data-test="signout-profile-button"
        tabIndex="0">
        <i>
          <FontAwesomeIcon icon={["far", "sign-in-alt"]} />
        </i>
        Sign Out
      </div>
    );
  }
}

const mapDispatchToProps = { signOutUser };

export default connect(null, mapDispatchToProps)(SignOut);
